import { Component, Input } from '@angular/core';
import { environment } from '@benefitsui/environments/environment';
import { AuthenticationService } from '@benefitsui/app/services/auth/authentication.service';
import { UserContextService } from '../../services/user-context/user-context.service';
import { BreadcrumbItem } from '../../reusable-components/breadcrumbs/breadcrumbs.types';

type TopRightMenuItem = {
  text: string;
  icon: string;
  onClick: () => void;
};

@Component({
  selector: 'app-sub-nav-layout',
  templateUrl: './sub-nav-layout.component.html',
  styleUrls: ['./sub-nav-layout.component.scss'],
  standalone: false,
  providers: [UserContextService]
})
export class SubNavLayoutComponent {
  @Input() returnPath: string = '/benefits';
  @Input() returnPathType: 'href' | 'routerLink' = 'routerLink';
  @Input() currentPath?: string;
  @Input() links?: BreadcrumbItem[];

  initialCountdown: number = environment.countdownSeconds;
  userFullName: string;
  topRightMenuItems: TopRightMenuItem[];

  constructor(
    private authService: AuthenticationService,
    private userContextService: UserContextService
  ) {
    const userContext = this.userContextService.get();
    this.userFullName = userContext?.currentUserFullName ?? '';
    
    this.topRightMenuItems = [
      {
        text: 'Log off',
        icon: 'lock',
        onClick: () => this.logout()
      }
    ];
  }

  logout() {
    this.authService.logout();
  }
}